















































































import Component from 'vue-class-component';

// Store types
import {
    SystemsGetter,
    SelectedToolSystems,
    ToolProduct,
    ProductsGetter,
    ToolProducts,
    ProductType,
} from '@/store/store.types';

// Steps and step types
import Steps from '@/steps/steps';
import { Step } from '@/steps/types';

// The base class for every step
import BaseStep from '../BaseStep.vue';

// Internal components
import OverviewSystem from './internals/system/OverviewSystem.vue';
import OverviewProduct from './internals/product/OverviewProduct.vue';

/**
 *  The fourth step: the overview.
 */
@Component({
    components: {
        OverviewSystem,
        OverviewProduct,
    },
})
export default class OverviewStep extends BaseStep {

    /**
     *
     *  Used to get the selected (suggestion) systems.
     *
     *  (i) We delibaretly get them from the suggestions (and not the request)
     *  to prevent unexpected behaviour for multi splits: a multi split's
     *  guid is added to multi spaces and a multi split can contain
     *  the same unit multiple times.
     *
     */
    private get selectedToolSystems(): SelectedToolSystems {

        return this.$store.getters[SystemsGetter.SUGGESTIONS_SELECTED];

    }

    /**
     *  Used to get all the selected products.
     */
    private get selectedProducts(): Array<ToolProduct> {

        const products: Array<ToolProduct>  = [];

        for (const product of this.$store.getters[ProductsGetter.ALL] as ToolProducts) {

            if (!product.selected) {

                continue;

            }

            products.push(product);

        }

        return products;

    }

    /**
     *  Used to get the selected service (tool) products.
     */
    private get selectedServiceProducts(): Array<ToolProduct> {

        return this.selectedProducts.filter((product: ToolProduct) => {

            return product.type === ProductType.Service;

        });

    }

    /**
     *  Used to get the selected additional (tool) products.
     */
    private get selectedAdditionalProducts(): Array<ToolProduct> {

        return this.selectedProducts.filter((product: ToolProduct) => {

            return product.type === ProductType.Additional;

        });

    }

    /**
     *  Reset the footer's floating action and next button when created.
     */
    private created(): void {

        /**
         *  Ensure there's no floating action set.
         */
        this.setFooterFloatingAction(null);

        /**
         *  Update the footer next accordingly.
         */
        this.setFooterNext({
            step: Steps[Step.PersonalDetails],
            disabled: false,
            action: () => {

                void this.$router.push(Step.PersonalDetails);

            },
        });

    }

    /**
     *  Invoke the base step's mounted hook when mounted.
     */
    private mounted(): void {

        this.stepMounted();

    }

}
